/**
 * Apply the parent-module switch on the company user roles tree.
 * Toggles `assigned` (persisted grant) and module-level actions; submodules stay
 * independent. Visual `checked` may remain true when only children are granted.
 *
 * @param {Record<string, unknown>} module
 * @param {boolean} checked
 * @returns {Record<string, unknown>}
 */
export function applyMainModuleToggle(module, checked) {
  const newActions = (module.actions || []).map((action) => ({
    ...action,
    assigned: checked,
    checked: checked,
  }));
  const hasAnyChild =
    newActions.some((a) => a.checked) ||
    (module.submodules || []).some((sub) => sub.checked || sub.assigned);
  return {
    ...module,
    assigned: checked,
    checked: checked || hasAnyChild,
    actions: newActions,
  };
}
